<ng-container>
  <td>{{ integration.config.getTypeDisplayString() }}</td>
  <td class="nowrap">{{ integration.name }}</td>
  <td>
    <button type="button" class="arpio-button" (click)="editIntegration()" title="Reconfigure">
      <svg lucideSquarePen></svg>
    </button>
    <button type="button" class="arpio-button" (click)="deleteIntegration()" title="Delete">
      <svg lucideTrash2></svg>
    </button>
  </td>
</ng-container>
